import {Box, styled, TextField, Typography, Button} from "@mui/material";
import {color} from "../../theme/includes/color";


export const AuthWrapper = styled(Box)({
  height: '100vh',
  width: '100%',
  padding: '40px',
  backgroundColor: color('blue-400'),
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  alignItems: 'center'
})
export const AuthContainer = styled(Box)({
  maxWidth: '672px',
  height: '100%',
  padding: '40px',
  backgroundColor: color('white-100'),
  borderRadius: '16px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
})
export const AuthHeader = styled(Box)({})
export const AuthTitle = styled(Typography)({
  fontSize: '56px'
})
export const AuthSubTitle = styled(Typography)({
  fontSize: '56px',
  lineHeight: 1,
  color: color('grey-100')
})
export const AuthFields = styled(Box)({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  columnGap: '32px',
})
export const AuthField = styled(Box)({
  minWidth: '280px',
})
export const AuthLabel = styled(Typography)({
  marginBottom: '12px'
})
export const AuthTextField = styled(TextField)({})
export const AuthAboutButton = styled(Button)({
  gridColumn: '1/3',
  marginBottom: '32px'
})
export const AuthFooter= styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
})
export const AuthAnswer = styled(Typography)({
  color: color('black-100')
})
export const AuthLinkButton = styled(Button)({
  color: color('blue-100')
})
